import service from './request';

/**   EG
 * 封装get post 的 两种方式
 * @param params 传入的阐述
 * @param path 为路径
 * @returns {Promise}
 */
// get
export const $getSendCode = (params = {}) => {
	return service.post('/path', params);
};
// 获取身份列表
export const $get_identity = (params = {}) => {
	return service.get('/through_train/get_identity', { params });
};
// 获取表单列表(我的问题反馈 表格数据)
export const $get_feedback_list = (params = {}) => {
	return service.get('/through_train/get_feedback_list', { params });
};
// 获取个人信息
export const $get_user_info = (params = {}) => {
	return service.get('/through_train/get_user_info', { params });
};
// 获取协议
export const $get_agreement = (params = {}) => {
	return service.get('/through_train/get_agreement', { params });
};

//文件上传
export const $upload = (params = {}) => {
	return service.post('/sidon/upload', params, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

// post
export const $postSendCode = (params = {}) => {
	return service.post('/path', params);
};
// 登录
export const $login = (params = {}) => {
	return service.post('/through_train/login', params);
};
// 手机号登录
export const $mobile_login = (params = {}) => {
	return service.post('/through_train/mobile_login', params);
};
// 发送验证码
export const $send_code = (params = {}) => {
	return service.post('/through_train/send_code', params);
};
// 注册
export const $register = (params = {}) => {
	return service.post('/through_train/register', params);
};
// 修改密码
export const $change_password = (params = {}) => {
	return service.post('/through_train/change_password', params);
};
// 编辑个人信息
export const $edit_user_info = (params = {}) => {
	return service.post('/through_train/edit_user_info', params);
};
// 退出登录
export const $login_out = (params = {}) => {
	return service.post('/through_train/login_out', params);
};
// 忘记密码
export const $resetpwd = (params = {}) => {
	return service.post('/through_train/reset_password', params);
};

//!======================================

// 获取轮播图
export const $get_banner_list = (params = {}) => {
	return service.get('/through_train/get_banner_list', params);
};
// 合理化建议(提交)
export const $add_feedback = (params = {}) => {
	return service.post('/through_train/add_feedback', params);
};
// 投诉举报(提交)
export const $add_complaint = (params = {}) => {
	return service.post('/through_train/add_complaint', params);
};
// 表彰表扬(提交)
export const $add_commend = (params = {}) => {
	return service.post('/through_train/add_commend', params);
};
// 合理化建议详情
export const $get_feedback = (params = {}) => {
	return service.get('/through_train/get_feedback', { params });
};
// 合理化建议详情-评价提交
export const $add_feedback_comment = (params = {}) => {
	return service.post('/through_train/add_feedback_comment', params);
};
// 联系我们
export const $get_contact = (params = {}) => {
	return service.get('/through_train/get_contact', params);
};
// 提交页提示
export const $data_type_des = (params = {}) => {
	return service.get('/through_train/data_type_des', { params });
};
// 建议类型
export const $get_type = (params = {}) => {
	return service.get('/through_train/get_type', { params });
};

/**
 * 封装post 上传formaData数据
 * @param url
 * @param formData  file参数记得使用 const formData = new FormData();
	   formData.append("file", file);
 * @returns {Promise}
 */
export const $uploadFormData = ({ formData, onUploadProgress = (e) => {} }) => {
	const config = {
		headers: {
			...service.defaults.headers,
			'Content-Type': 'multipart/form-data',
		},
		onUploadProgress,
	};
	return service.post(`/upload`, formData, config);
};
/** */
